import axios from "axios";
import router from "@/router";

const getDefaultState = () => {
  return {
    allDevices: [],
    allDevicesLoading: false,
    fields: {
      ALL_DEVICES: `
        id
        order {
          id
          customer {
            id
            company_name
          }
        }
        imei
        status              
        created_at
        updated_at
      `
    }
  };
};

const state = getDefaultState();

const getters = {
  getAllDevices(state) {
    return state.allDevices;
  },
  getAllDevicesLoading(state) {
    return state.allDevicesLoading;
  }
};

const actions = {
  fetchAllDevices({ commit, dispatch, state }) {
    commit("setAllDevicesLoading", true);

    const data = {
      query: `
        query {
          allDevices(limit: 20) { ${state.fields.ALL_DEVICES} }
        }
      `
    };
    const data_1 = {
      query: `
        query {
          allDevices(offset: 20) { ${state.fields.ALL_DEVICES} }
        }
      `
    };

    dispatch("fetchDevices", { data: data, commit_to: "setAllDevices" }).then(
      () => {
        dispatch("fetchDevices", {
          data: data_1,
          commit_to: "setAddToAllDevices"
        }).then(() => {
          commit("setAllDevicesLoading", false);
        });
      }
    );
  },
  fetchDevices({ commit, rootGetters }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(rootGetters.getGraphQlUrl, payload.data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
          } else {
            let devices = res.data.data.allDevices.map(device => {
              return {
                id: device.id,
                status: device.status,
                imei: device.imei,
                order_id: device.order.id,
                customer_id: device.order.customer.id,
                created_at: device.created_at,
                updated_at: device.updated_at,
                customer: device.order.customer.company_name,
                _rowVariant:
                  device.status === "active"
                    ? "success"
                    : device.status === "terminated"
                      ? "danger"
                      : "info"
              };
            });
            commit(payload.commit_to, devices);
          }
        })
        .catch(err => {
          alert(err);
          console.error(err);
        })
        .then(() => {
          resolve();
        });
    });
  }
};

const mutations = {
  setAllDevices(state, value) {
    state.allDevices = value;
  },
  setAddToAllDevices(state, value) {
    state.allDevices.push(...value);
  },
  setAllDevicesLoading(state, value) {
    state.allDevicesLoading = value;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
